import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { App } from '@/components'
import { locales } from '@/locales'

import reportWebVitals from './reportWebVitals'
import './index.scss'

i18n.use(initReactI18next).init({
	resources: locales,
	lng: 'id',
	fallbackLng: 'id',
	interpolation: {
		escapeValue: false
	}
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<StrictMode>
		<App />
	</StrictMode>
)

reportWebVitals()
